import React from 'react';
import { useSelector } from 'react-redux';

// Types
import { Illustrations } from 'Wpds/components/illustration';

// Helpers
import { getFirstName } from 'Shared/helpers';

// Components
import GiveKudosButton from 'Shared/components/GiveKudosButton/GiveKudosButton';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

// Styles
import './FeedbackEmptyState.scss';

const FeedbackEmptyState = () => {
  const teammateNameOrSomeone = useSelector(state => {
    const { isGroup, users, name } = state.workspace;

    if (isGroup) return 'someone';

    const currentUserId = state.user.id;
    const restUser = users.find(({ id: userId }) => userId !== currentUserId);
    return restUser ? getFirstName(restUser.fullName) || getFirstName(name) || restUser.email : getFirstName(name);
  });

  const baseClassName = 'FeedbackEmptyState';

  return (
    <div className={baseClassName}>
      <EmptyStateContainer
        title="No one has given kudos yet"
        subTitle={`Start things out by giving ${teammateNameOrSomeone} a Kudos!`}
        image={Illustrations.person_on_mountain_with_lens_with_white_bg}
        button={<GiveKudosButton />}
      />
    </div>
  );
};

export default FeedbackEmptyState;
